import styled from 'styled-components';
import {Space} from 'antd';
import DetailsTable from '../../TransactionsPage/DetailsTable';
import {typographyStyles} from "../../../../utils/styles";


const StyledBudgetRequestDetails = styled.div`
  form {

    .ant-form-item {
      margin-bottom: 0;

      &:not(.w-100) {
        .ant-form-item-control-input,
        .ant-picker {
          min-width: 214px;
        }
      }
    }

    .invoice-vendor-select {
      &.padding-0 {
        .ant-dropdown-trigger {
          padding: 0;
        }
      }
      .ant-form-item-control-input {
        max-width: 214px;
        width: max-content;
      }
    }

    .ant-form-item-label {
      display: none;
    }

    .ant-input {
      &:not(textarea) {
        text-align: right;
      }
    }

    .ant-input,
    .ant-input-affix-wrapper,
    .ant-picker {
      &:not(:active):not(:focus):not(:hover) {
        border-color: transparent;
      }
    }

    .ant-picker {
      &.ant-picker-disabled {
        background: transparent;
        &:active,
        &:focus,
        &:hover {
          border-color: transparent;
        }
      }

      .ant-picker-input {
        input {
          margin-right: 16px;
          text-align: right;

          &[disabled] {
            color: rgba(0, 0, 0, 0.88);
          }
        }
      }
    }

    .ant-form-item-with-help {
      text-align: left;
    }

    .invoice-vendor-select {
      .ant-dropdown-trigger {
        border-color: transparent;
        font-size: 14px;
        justify-content: end;
        min-height: 32px;
        padding: 4px 12px;

        &:hover {
          border-color: ${props => props.theme.colors.primary_8};
        }
      }
    }

    .tags-select {
      .ant-select-selector {
        border-color: transparent;
      }
    }

    .ant-select-selector {
      .ant-select-selection-item {
        & > .ant-space {
          justify-content: end;
        }
      }
    }
  }
`;

const StyledBudgetRequestDetailsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledBudgetRequestDetailsHeaderTitle = styled.div`
  ${typographyStyles.heading.h4};
  color: ${props => props.theme.colors.neutral_10};
  width: 100%;

  .ant-input {
    text-align: left !important;
  }

  .ant-form-item-control-input {
    width: unset !important;
  }

  .ant-input-affix-wrapper {
    ${typographyStyles.heading.h4};
    color: ${props => props.theme.colors.neutral_10};

    .ant-input-prefix {
      color: ${props => props.theme.colors.neutral_7};
    }
  }
`;

const StyledBudgetRequestDetailsHeaderAmount = styled.div`
  ${typographyStyles.heading.h5};
  color: ${props => props.theme.colors.neutral_8};
  text-wrap: nowrap;

  .amount-input {
    .ant-input-prefix,
    input {
      ${typographyStyles.heading.h5};
      color: ${props => props.theme.colors.neutral_8} !important;
    }
  }
`;

const StyledBudgetRequestDetailsVendorSpace = styled(Space)`
  justify-content: end;
`;

const StyledBudgetRequestDetailsTable = styled(DetailsTable)`
  tr {
    min-height: 34px;

    &:not(:last-of-type) {
      margin-bottom: 0;
    }
  }
`;

export {
  StyledBudgetRequestDetails,
  StyledBudgetRequestDetailsHeader,
  StyledBudgetRequestDetailsHeaderTitle,
  StyledBudgetRequestDetailsHeaderAmount,
  StyledBudgetRequestDetailsVendorSpace,
  StyledBudgetRequestDetailsTable,
}
